import { render } from "./MatchByNeed.vue?vue&type=template&id=21df0668"
import script from "./MatchByNeed.vue?vue&type=script&lang=js"
export * from "./MatchByNeed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__